import { GameId } from '@bg-shared/enums/GameId';
import { ClassicGameDefinition } from '@bg-shared/utils/ClassicGameDefinition';

const GAME_INFO_V1_PREFIX = 'game-info';

export const GAME_INFO_V2_PREFIX = 'game-info:v2';

export const GAME_STATE_CHANNEL_PREFIX = 'game_state_';

export const VIDEO_READY_V1_PREFIX = 'run-video-ready:v1:';

export const PLS_GAME_INFO_PREFIX = 'pls-game-info';

export const GAME_INFO_CHANNELS: Partial<Record<GameId, string>> = {
    [GameId.POKER]: `${GAME_INFO_V2_PREFIX}:${GameId.POKER}`,
    [GameId.BACCARAT]: `${GAME_INFO_V2_PREFIX}:${GameId.BACCARAT}`,
    [GameId.WAR]: `${GAME_INFO_V2_PREFIX}:${GameId.WAR}`,
    [GameId.SIX_PLUS_POKER]: `${GAME_INFO_V2_PREFIX}:${GameId.SIX_PLUS_POKER}`,
    [GameId.STS_POKER]: `${GAME_INFO_V2_PREFIX}:${GameId.STS_POKER}`,
    [GameId.DICE_DUEL]: `${GAME_INFO_V1_PREFIX}:${GameId.DICE_DUEL}`,
    [GameId.RNG_FOOTBALL_GRID]: `${GAME_INFO_V1_PREFIX}:${GameId.RNG_FOOTBALL_GRID}`,
    [GameId.WHEEL]: `${GAME_INFO_V1_PREFIX}:${GameId.WHEEL}`,
    [GameId.RNG_WHEEL]: `${GAME_INFO_V1_PREFIX}:${GameId.RNG_WHEEL}`,
    [GameId.LUCKY5]: `${GAME_INFO_V1_PREFIX}:${GameId.LUCKY5}`,
    [GameId.LUCKY6]: `${GAME_INFO_V1_PREFIX}:${GameId.LUCKY6}`,
    [GameId.LUCKY7]: `${GAME_INFO_V1_PREFIX}:${GameId.LUCKY7}`,
    [GameId.BETWAY_LUCKY7]: `${GAME_INFO_V1_PREFIX}:${GameId.BETWAY_LUCKY7}`,
    [GameId.RNG_LUCKY7]: `${GAME_INFO_V1_PREFIX}:${GameId.RNG_LUCKY7}`,
    [GameId.SHOVA52]: `${GAME_INFO_V1_PREFIX}:${GameId.SHOVA52}`,
    [GameId.LUCKY_KICKS]: `${GAME_INFO_V1_PREFIX}:${GameId.LUCKY_KICKS}`,
    [GameId.STARZLE]: `${GAME_INFO_V1_PREFIX}:${GameId.STARZLE}`,
    [GameId.GIZA]: `${GAME_INFO_V1_PREFIX}:${GameId.GIZA}`,
    ...[
        ...ClassicGameDefinition.SKYWARD_GAMES_IDS,
        ...ClassicGameDefinition.ROULETTE_GAMES_IDS,
    ].reduce(
        (result, id) => ({
            ...result,
            [id]: `${GAME_INFO_V1_PREFIX}:${id}`,
        }),
        {},
    ),
};

export const PLS_GAME_INFO_CHANNELS = ClassicGameDefinition.PLS_GAMES_IDS.reduce(
    (acc, gameId) => {
        acc[gameId] = `${PLS_GAME_INFO_PREFIX}:${gameId}`;
        return acc;
    },
    {} as Record<keyof typeof ClassicGameDefinition.PLS_GAMES_IDS, string>,
);

export const LAST_RESULTS_V2_GAMES_LIST = [
    GameId.WHEEL,
    GameId.SHOVA52,
    GameId.LUCKY_KICKS,
    GameId.STARZLE,
    ...ClassicGameDefinition.SKYWARD_GAMES_IDS,
    ...ClassicGameDefinition.ROULETTE_GAMES_IDS,
];

export const BACCARAT_STATISTICS_CHANNEL = 'baccarat_statistics';

export const WAR_OF_BETS_SHUFFLE_DECK = 'war_shuffle_deck';

export const BACCARAT_SHUFFLE_DECK = 'baccarat_shuffle_deck';

export const FLASH_ROULETTE_MULTIPLIERS = 'flash-roulette-multipliers-revealed';

export const CANCELLED_DRAW_CHANNEL_PREFIX = 'lottery_returned_';

export const LAST_RESULT_CHANNEL_PREFIX = 'last_result_';

export const GAME_STATISTICS_CHANNEL_PREFIX = 'game-statistics:';

export const LAST_RESULTS_CHANNEL_PREFIX = 'last_results:';

export const LAST_RESULTS_CHANNEL_PREFIX_V2 = 'last-results:v2:';

export const GAME_ITEM_ADDED_PREFIX = 'game-item-added:v1:';

export const GAME_ITEM_CANCELED_PREFIX = 'game-item-cancelled:v1:';

export const TOP_WON_AMOUNTS_CHANNEL_PREFIX = 'top-won-amounts:';

export const RERUN_CHANNEL = 'rerun';

export const PROMOTION_CHANNEL = 'notifications';

export const REFRESH_IFRAME = 'refresh_iframe';

export const BALANCE_UPDATE = 'player_balance';

export const PROMOTION_NEW_CHANNEL = 'promotion';

export const PROMOTION_PAID_OUT = 'promotion_paid_out';

export const RECENT_BETS = 'recent_bets';

export const PLAYER_WON_CHANNEL = 'player_won';

export const REFRESH_CONNECTION = 'refresh-connection';

export const GAMIFICATION_ASSET = 'gamification-asset-purchase:v1';

export const STARZLE_CHANNELS = {
    bonusRound: 'starzle-bonus-round:v1',
    bonusRoundResult: 'starzle-bonus-round-result:v1',
    bonusBalls: 'starzle-bonus-balls-revealed:v1',
    playerQualified: 'starzle-player-bonus-round-streak-status:v1',
};

export const GIZA_CHANNELS = {
    bonusRound: 'giza-bonus-round:v1',
    mainBonusRoundResult: 'giza-main-bonus-round-result:v1',
    sideBonusRoundResult: 'giza-side-bonus-round-result:v1',
    bonusGameAutoChoice: 'giza-bonus-game-auto-choice:v1',
    sectorsRevealed: 'giza-sectors-revealed:v1',
    cameraSwitch: 'giza-camera-switch:v2',
    playerQualified: 'giza-player-bonus-round-streak-status:v1',
};

export const LIST_TYPE_DATA_CHANNELS = [
    `${LAST_RESULTS_CHANNEL_PREFIX_V2}${GameId.WHEEL}`,
    GAME_ITEM_ADDED_PREFIX,
    `${LAST_RESULTS_CHANNEL_PREFIX_V2}${GameId.SHOVA52}`,
    `${LAST_RESULTS_CHANNEL_PREFIX_V2}${GameId.LUCKY_KICKS}`,
    `${LAST_RESULTS_CHANNEL_PREFIX_V2}${GameId.STARZLE}`,
    STARZLE_CHANNELS.bonusRound,
    STARZLE_CHANNELS.bonusRoundResult,
    ...ClassicGameDefinition.SKYWARD_GAMES_IDS.map(
        (id) => `${LAST_RESULTS_CHANNEL_PREFIX_V2}${id}`,
    ),
    ...ClassicGameDefinition.ROULETTE_GAMES_IDS.map(
        (rouletteGameId) => `${LAST_RESULTS_CHANNEL_PREFIX_V2}${rouletteGameId}`,
    ),
];

export const SKYWARD_CHANNELS = {
    cashOut: 'skyward-cashout:v1',
    payIn: 'skyward-payin:v1',
    cancelBet: 'skyward-cancel-bet:v1',
    timeoutMultiplier: 'skyward-timeout-multiplier:v1',
};

export const STAGED_BETS_RESPONSE = 'staged-bet-partner-api-response:v1';
